<div class="avatar-border" [ngStyle]="{ 'border-color': backgroundColor }">
  <div class="avatar" [ngStyle]="{ 'background-color': backgroundColor }">
    <img *ngIf="src" [src]="src" alt="Avatar" />
    <span *ngIf="!src">{{ initials }}</span>
  </div>
</div>
